import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { useSaveDownloaded } from "../../../../../lib/hooks/useSaveDownloaded";
import ReportService from "../../../../../services/reportGeneration";

export const useExport = (form: FormInstance, closeModal: () => void) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { save } = useSaveDownloaded(
    "zip-codes.xlsx",
    "application/octet-stream",
  );

  const onExport = useCallback(async () => {
    try {
      const req = form.getFieldsValue();

      setIsLoading(true);

      const res = await ReportService.exportByName("CustomerZipCodeRanks", req);

      save(res);

      closeModal();

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [form, save, closeModal]);

  return { isLoading, onExport };
};
